import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import {withRouter} from "react-router-dom";

import ClassroomTrialTable from "./ClassroomTrialTable";

class ClassroomTrialList extends Component {

    render() {
        document.title ="Lezioni Gratuite | CLTV";

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Lezioni Gratuite" pageTitle="CLTV"/>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <ClassroomTrialTable />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(ClassroomTrialList);
